<template>
    <div class="rating-prizes">
        <div class="flex">
            <img
                alt="glove"
                class="rating-prizes_glove"
                src="@/assets/Competition/Raffle/additional-info/glove.svg">
            <div class="rating-prizes_t-shirt">
                <img
                    alt="t-shirt"
                    class="rating-prizes_t-shirt__img"
                    src="@/assets/Competition/Raffle/additional-info/t-shirt.svg">
                <i18n
                    class="rating-prizes_t-shirt__text"
                    path="common.rating.banner.webmaster.print">
                    <template #merch>
                        <p style="font-size: clamp(1.125rem, 0.4302rem + 0.8915vw, 1.5rem);">
                            {{ $t("common.rating.banner.webmaster._merch") }}
                        </p>
                    </template>
                </i18n>
            </div>
            <img
                alt="suitcase"
                class="rating-prizes_suitcase"
                src="@/assets/Competition/Raffle/additional-info/suitcase.svg">
        </div>

        <CompetitionRatingButtons v-if="isWebmasterRole">
        </CompetitionRatingButtons>
    </div>
</template>

<script>
  import CompetitionRatingButtons from "@/components/Common/Competition/CompetitionRatingButtons.vue";
  import { mapGetters } from "vuex";

  export default {
    components: { CompetitionRatingButtons },
    
    computed: {
      ...mapGetters(["role"]),

      isWebmasterRole () {
        return this.role === "webmaster";
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "~@/scss/competition-banner";

  .wrapper-button {
    position: absolute;
    bottom: clamp(1rem, 0.0736rem + 1.1887vw, 1.5rem); // 24px
    right: clamp(1rem, 0.0736rem + 1.1887vw, 1.5rem); // 24px
  }

  .rating-prizes {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;

    margin-left: auto;
    height: 100%;

    @media screen and (max-width: 960px) {
      display: none;
    }

    &_glove {
      width: clamp(3.125rem, 0.3457rem + 3.5661vw, 4.625rem); // 74px
      height: clamp(10rem, 0.7355rem + 11.8871vw, 15rem); // 240px
      margin-right: clamp(1.625rem, -3.0072rem + 5.9435vw, 4.125rem); // 66px
      margin-top: -20px;
    }

    &_t-shirt {
      position: relative;

      width: clamp(5.5rem, 0.2887rem + 6.6865vw, 8.3125rem); // 133px
      height: clamp(10.75rem, 0.7907rem + 12.7786vw, 16.125rem); // 258px
      margin-top: -20px;

      &__img {
        width: 100%;
        height: 100%;
      }

      &__text {
        position: absolute;
        @extend %centerStyle;
        top: 63%;

        font-weight: 700;
        font-size: clamp(0.875rem, 0.6434rem + 0.2972vw, 1rem); // 16px
        line-height: 136%;
        letter-spacing: -0.03em;
        text-align: center;
        text-transform: uppercase;
      }
    }

    &_suitcase {
      width: clamp(11.5625rem, 5.888rem + 7.2808vw, 14.625rem); // 234px
      height: clamp(11.5rem, 0.73rem + 13.8187vw, 17.3125rem); // 277px
      margin-top: clamp(0.625rem, -1.1121rem + 2.2288vw, 1.5625rem); // 25px
      margin-right: clamp(-0.875rem, -2.4963rem + 2.0802vw, 0rem);
    }
  }
</style>